module.exports = __webpack_public_path__ + "media/images/favicon/mstile-144x144-d75189d70549767ea305c6bcfbf74996.png";